import createReactComponent from '../createReactComponent';
export default createReactComponent('git-commit', 'IconGitCommit', [
  ['path', { d: 'M12 12m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0', key: 'svg-0' }],
  ['path', { d: 'M12 3l0 6', key: 'svg-1' }],
  ['path', { d: 'M12 15l0 6', key: 'svg-2' }],
]);
